import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgShip = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="m11.666 6.057-9 3.189a1 1 0 0 0-.597 1.307l2.666 6.812a1 1 0 0 0 .932.635h12.666a1 1 0 0 0 .932-.635l2.666-6.812a1 1 0 0 0-.597-1.307l-9-3.189a1 1 0 0 0-.668 0ZM12 8.06l7.692 2.726L17.651 16H6.348l-2.04-5.214 7.691-2.726Z" />
      <path d="M17.5 3h-11a1 1 0 0 0-1 1v4.948l.007.12a1 1 0 0 0 1.327.823l5.165-1.831 5.166 1.83a1 1 0 0 0 1.334-.942L18.5 4a1 1 0 0 0-1-1Zm-1 2-.001 2.533-4.165-1.476-.132-.036a1 1 0 0 0-.536.036L7.5 7.533V5h9Z" />
      <path d="M12 1a1 1 0 0 1 .993.883L13 2v2a1 1 0 0 1-1.993.117L11 4V2a1 1 0 0 1 1-1ZM12 7a1 1 0 0 1 .993.883L13 8v4a1 1 0 0 1-1.993.117L11 12V8a1 1 0 0 1 1-1ZM18.247 19.341a1 1 0 0 1 1.582 1.218l-.076.1-1.75 2a1 1 0 0 1-1.416.09l-.09-.09-.997-1.141-.997 1.14a1 1 0 0 1-1.416.091l-.09-.09L12 21.518l-.997 1.14a1 1 0 0 1-1.416.091l-.09-.09-.997-1.141-.997 1.14a1 1 0 0 1-1.416.091l-.09-.09-1.75-2a1 1 0 0 1 1.417-1.407l.089.09.997 1.139.997-1.14a1 1 0 0 1 1.416-.09l.09.09.997 1.14.997-1.14a1 1 0 0 1 1.416-.09l.09.09.997 1.14.997-1.14a1 1 0 0 1 1.416-.09l.09.09.997 1.14.997-1.14Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgShip)
const Memo = memo(ForwardRef)
export default Memo
